import axios from 'axios';
import apiConfig from '../../api.config';

export default function updatePaperlessDevice({ oldUUID, newUUID, paperlessLockCarrusel }) {
  const {
    host,
    URIs: { updateDevice },
  } = apiConfig;

  const data = {
    oldUUID,
    newUUID,
    paperlessLockCarrusel,
  };

  const uri = `${host}${updateDevice}`;

  return axios.put(uri, data).then(res => res.data);
}
